<template>
    <ml-layout title="实践教学管理平台" :nav="nav">
        <div class="ml-main">
            <div class="title">{{ title }}</div>
            <div class="date">{{ date }}</div>
            <div class="content" v-html="content"></div>
        </div>
    </ml-layout>
</template>

<script>
import { getArticleInfo } from "@/api/views/lab";

import MlLayout from "@/components/MlLayout";

export default {
    name: "Home",
    components: {
        MlLayout
    },
    data() {
        return {
            nav: [
                { title: "首页", path: ["/"] },
                { title: "虚拟实验", path: ["/virtualExp", "/declareExp"] }
            ],
            title: null,
            date: null,
            content: null
        };
    },
    created() {
        getArticleInfo({
            id: this.$route.query.id
        }).then(res => {
            this.title = res.data.title;
            this.date = res.data.addtime;
            this.content = res.data.content;
        });
    }
};
</script>

<style scoped>
.ml-main {
    margin-top: 20px;
    background-color: #fff;
}

.title {
    text-align: center;
    font-size: 24px;
}

.date {
    float: right;
    margin-right: 20px;
}

.content {
    padding: 20px;
}
</style>
